const manufacturingJobTypes = [
  'assemblyLineWorker',
  'forkLiftDriver',
  'machineOperator',
  'qualityControl',
  'skilledTrades',
];

const hospitalityJobTypes = [
  'catering',
  'bartending',
  'dishwashing',
  'eventSetup',
  'foodPrep',
  'houseKeeping',
  'lineCook',
];

const healthcareJobTypes = ['CNA', 'LPN', 'RN'];

const allJobTypes = [...manufacturingJobTypes, ...hospitalityJobTypes, ...healthcareJobTypes];

module.exports = {
  manufacturingJobTypes,
  hospitalityJobTypes,
  healthcareJobTypes,
  allJobTypes,
};
